import { render, staticRenderFns } from "./CDOrganizationMobileInfoCard.vue?vue&type=template&id=7e2a80fb&scoped=true"
import script from "./CDOrganizationMobileInfoCard.vue?vue&type=script&lang=ts"
export * from "./CDOrganizationMobileInfoCard.vue?vue&type=script&lang=ts"
import style0 from "./CDOrganizationMobileInfoCard.vue?vue&type=style&index=0&id=7e2a80fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2a80fb",
  null
  
)

export default component.exports